import React, { useEffect, useState } from 'react';
import wallet1 from "../../images/shapes/Wallet01 5.png";
import wallet2 from "../../images/shapes/Wallet03.1 1.png";
import dollarY from "../../images/shapes/Dollar Bag (1).png";
import dollarG from "../../images/shapes/Dollar Bag.png";
import gift from "../../images/shapes/Gift.png";
import history1 from "../../images/shapes/Group 37483.png";
import WalletCard from "../../components/RetailerBusinessAgent/WallertCard";
import oldbank from "../../images/shapes/bank-pound-icon2 4.png";
import withdrawIcon from "../../images/shapes/withdraw-icon.png"; // You'll need to add this icon
import { useNavigate, useLocation, useSearchParams } from 'react-router-dom'; 
import WelcomeModal from "../../components/RetailerBusinessAgent/WelcomeModal"; 
import { API_URL } from "../../constant";

function RetailerAgentWallet() {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [referralData, setReferralData] = useState(null);
  const [user, setUser] = useState(null);
  const [walletData, setWalletData] = useState(null);
  const [authChecked, setAuthChecked] = useState(false);
  const [showModal, setShowModal] = useState(false); 
  const [containerStyle, setContainerStyle] = useState({});

  // Set container style on mount
  useEffect(() => {
    setContainerStyle({
      display: "flex",
      flexDirection: "column",
      marginTop: "0px",
      marginBottom: "0px",
      background: "linear-gradient(to bottom, #80302b, white)",
      width: "100%",
      minHeight: "100vh",
      fontFamily: "'Poppins', sans-serif",
      padding: "20px"
    });
  }, []);

  // Check if modal has been shown before for this user
  const hasModalBeenShown = () => {
    const userId = user?.id || user?.email;
    if (!userId) return false;
    
    const shownModals = JSON.parse(localStorage.getItem("shown_welcome_modals") || "{}");
    return shownModals[userId] === true;
  };

  // Mark modal as shown for this user
  const markModalAsShown = () => {
    const userId = user?.id || user?.email;
    if (!userId) return;
    
    const shownModals = JSON.parse(localStorage.getItem("shown_welcome_modals") || "{}");
    shownModals[userId] = true;
    localStorage.setItem("shown_welcome_modals", JSON.stringify(shownModals));
  };

  useEffect(() => {
    // Check for temp_token_key in URL first
    const tempTokenKey = searchParams.get('temp_token_key');
    
    if (tempTokenKey) {
      // Try to get token from localStorage using the temp key
      const tempToken = localStorage.getItem(tempTokenKey);
      
      if (tempToken) {
        // Store the real token in the standard location
        localStorage.setItem("auth_token", tempToken);
        localStorage.setItem("user_type", "retail_business");
        
        // Clean up the temp token
        localStorage.removeItem(tempTokenKey);
        
        // Remove the temp_token_key from URL without reloading
        const newUrl = window.location.pathname;
        window.history.replaceState({}, document.title, newUrl);
        
        console.log("Token successfully transferred from temp storage");
      }
    }
    
    // Now fetch wallet data
    fetchWalletData();
  }, [location.pathname, searchParams]);

  const fetchWalletData = async () => {
    const token = localStorage.getItem("auth_token");
    
    if (!token) {
      navigate("/retail-business");
      return;
    }

    setIsLoading(true);
    try {
      // Get user data
      const userResponse = await fetch(`${API_URL}/api/retail-business/me`, {
        headers: {
          "Authorization": `Bearer ${token}`,
        },
      });

      if (!userResponse.ok) throw new Error("Failed to fetch user data");
      const userData = await userResponse.json();
      setUser(userData.user);

      // Check if modal should be shown for this user
      const userId = userData.user?.id || userData.user?.email;
      if (userId) {
        const shownModals = JSON.parse(localStorage.getItem("shown_welcome_modals") || "{}");
        if (!shownModals[userId]) {
          setShowModal(true);
        }
      }

      // Get wallet details
      const walletResponse = await fetch(`${API_URL}/api/retail-business/wallet`, {
        headers: {
          "Authorization": `Bearer ${token}`,
        },
      });

      if (!walletResponse.ok) throw new Error("Failed to fetch wallet data");
      const walletData = await walletResponse.json();
      setWalletData(walletData.data);

      // Transform to referral data format
      const transformedData = {
        user: {
          firstName: userData.user.first_name,
          sureName: userData.user.last_name,
          fullName: `${userData.user.first_name} ${userData.user.last_name}`,
          role: "Retail Business", // Updated role for retail business
          avatar: userData.user.photo_url || "",
          email: userData.user.email,
          phone: userData.user.phone,
          id: userData.user.id,
        },
        earnings: {
          topcoinValue: walletData.total_points?.primary || 0,
          topcoinGBP: (walletData.total_points?.primary || 0) / 100,
          earnedBonus: walletData.total_points?.retail_agent || 0,
          earnedBonusCash: walletData.earned_bonus_reward_wallet?.cash ?? 0,
        }
      };
      setReferralData(transformedData);
      
      // Also set auth as checked
      setAuthChecked(true);

    } catch (error) {
      console.error("Error fetching wallet data:", error);
      setError(error.message);
      
      // If token is invalid, redirect to login
      if (error.message.includes("401") || error.message.includes("Failed to fetch user data")) {
        localStorage.removeItem("auth_token");
        localStorage.removeItem("user_type");
        navigate("/retail-business");
      }
    } finally {
      setIsLoading(false);
    }
  };

  // Listen for messages from the login page
  useEffect(() => {
    const handleMessage = (event) => {
      // Ensure the message is from the same origin
      if (event.origin !== window.location.origin) return;
      
      if (event.data.type === "LOGIN_SUCCESS") {
        console.log("Received login success message from parent");
        // Store the token if provided
        if (event.data.token) {
          localStorage.setItem("auth_token", event.data.token);
          localStorage.setItem("user_type", "retail_business");
          
          // Clean up temp token if provided
          if (event.data.tempTokenKey) {
            localStorage.removeItem(event.data.tempTokenKey);
          }
          
          // Refresh data
          fetchWalletData();
        }
      }
    };

    window.addEventListener("message", handleMessage);
    
    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, []);

  const handleCloseModal = () => {
    setShowModal(false);
    markModalAsShown();
  };

  if (isLoading) {
    return (
      <div style={{ 
        ...containerStyle,
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh' 
      }}>
        <div style={{ marginTop: '20px', textAlign: 'center' }}>
          <div style={{
            width: '40px',
            height: '40px',
            border: '4px solid #f3f3f3',
            borderTop: '4px solid #3498db',
            borderRadius: '50%',
            animation: 'spin 1s linear infinite',
            margin: '0 auto'
          }}></div>
          <style>{`
            @keyframes spin {
              0% { transform: rotate(0deg); }
              100% { transform: rotate(360deg); }
            }
          `}</style>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div style={{ 
        ...containerStyle,
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh' 
      }}>
        <div style={{ color: 'red', textAlign: 'center' }}>
          <h3>Error Loading Wallet</h3>
          <p>{error}</p>
          <button 
            onClick={() => navigate("/retail-business")}
            style={{
              backgroundColor: '#2D4CA8',
              color: 'white',
              border: 'none',
              padding: '10px 20px',
              borderRadius: '6px',
              cursor: 'pointer',
              marginTop: '20px'
            }}
          >
            Return to Login
          </button>
        </div>
      </div>
    );
  }

  if (!referralData) {
    return null;
  }

  return (
    <div style={containerStyle}>
      <div className="wallet-container1">
        <WalletCard
          imgH={wallet2}
          imgT={dollarG}
          imgHi={history1}
          title="TopCoin Wallet (Retail)"
          amount={`${referralData.earnings.topcoinValue}`}
          subText="Available TopCoin"
          bgColor="#f0fdf4"
          historyLink="/topcoin-history"
          bgColor1='#dcfce7'
        />

        <WalletCard
          imgH={wallet1}
          imgT={dollarY}
          imgHi={history1}
          title="Earned Bonus Reward Wallet (Retail)"
          amount={`£ ${parseFloat(referralData.earnings.earnedBonusCash || 0).toFixed(2)}`}
          subText="Cash Reward"
          bgColor="#fff7ed"
          historyLink="/topcoin-history"
          bgColor1='#ffedd5'
        />
        
        {/* <WalletCard
          imgH={wallet1}
          imgT={gift}
          imgHi={history1}
          title="Bonus Wallet (Network)"
          amount={`£ ${referralData.earnings.earnedBonus.toFixed(2)}`}
          subText="Earned Bonus"
          bgColor="#fff7ed"
          bgColor1='#ffedd5'
          historyLink="/bonus-history"
        /> */}

        {/* <WalletCard
          imgH={wallet1}
          imgHi={history1}
          imgT={dollarY}
          title="Reward Cash Wallet (Network)"
          amount={`£ ${(referralData.earnings.topcoinGBP + referralData.earnings.earnedBonus).toFixed(2)}`}
          subText="Available Cash"
          bgColor="#fffbeb"
          bgColor1='#fef3c7'
          historyLink="/cash-history"
        /> */}


        {/* Withdraw Card - Disabled/Grayed out */}
                <WalletCard
                  imgH={oldbank}
                 // Changed to withdraw icon
                  imgT={dollarY}
                  title="Withdrawal"
                  // amount={`£ ${(referralData.earnings.topcoinGBP + referralData.earnings.earnedBonus).toFixed(2)}`}
                  amount="£ 0.00"
                  subText="Available Cash"
                  bgColor="#f5f5f5" // Gray background for disabled state
                  bgColor1='#e0e0e0' // Darker gray for icon background
                  historyLink="#" // No link since it's disabled
                  buttonText="Withdraw" // Changed button text
                  disabled={true} // Make it disabled
                  showButton={true} // Show the button (but disabled)
                />
      </div>

     
      {showModal && (
        <WelcomeModal user={referralData.user} onClose={handleCloseModal} />
      )}
    </div>
  );
}

export default RetailerAgentWallet;